module.exports = __webpack_public_path__ + "img/pencil-blue.060d55c5.svg";